import { render } from "./CompletedMovesPage.vue?vue&type=template&id=3484f8ec&scoped=true"
import script from "./CompletedMovesPage.vue?vue&type=script&lang=js"
export * from "./CompletedMovesPage.vue?vue&type=script&lang=js"

import "./CompletedMovesPage.vue?vue&type=style&index=0&id=3484f8ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3484f8ec"]])

export default __exports__